import { Button, Typography } from '@mui/material'
import { Label } from '$common/label'
import { t } from '$i18n'
import { TextInput } from '$common/input'
import { PrimaryButton } from '$common/buttons'
import { ButtonsContainer, FormContainer } from '../style-components'
import { Alert } from '$common/input/alert'

interface Props {
  title: string
  titlePlaceholder?: string
  onChangeTitle: (title: string) => void
  onStartNow: () => void
  onSchedule: () => void
  titleError: string
}
export function StartNowForm({
  title,
  onChangeTitle,
  onStartNow,
  onSchedule,
  titlePlaceholder,
  titleError,
}: Props) {
  return (
    <>
      <FormContainer sx={{ mb: '24px' }}>
        <Label
          typographyProps={{ variant: 'subtitle3' }}
          title={t('chooseHallCallTimeModal.title')}
          inParentheses={t('chooseHallCallTimeModal.optional')}
        />
        <TextInput
          value={title}
          onChange={onChangeTitle}
          placeholder={
            titlePlaceholder || t('chooseHallCallTimeModal.titlePlaceholder')
          }
          rootSx={{ mb: 0 }}
        />
        {titleError && <Alert variant="error" text={titleError} />}
      </FormContainer>
      <ButtonsContainer sx={{ flexDirection: 'column', gap: '8px' }}>
        <PrimaryButton
          sx={{ height: '48px' }}
          fullWidth
          text={
            <Typography variant="subtitle1" color="inherit">
              {t('chooseHallCallTimeModal.startNow')}
            </Typography>
          }
          onClick={onStartNow}
        />

        <Button
          sx={{ height: '48px' }}
          onClick={onSchedule}
          fullWidth
          variant="text"
          size="large"
          color="primary"
        >
          <Typography color="primary500" variant="subtitle3">
            {t('chooseHallCallTimeModal.scheduleForLater')}
          </Typography>
        </Button>
      </ButtonsContainer>
    </>
  )
}
